<template>
    <div class="position-box">
        <div class="head">
          <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="goBack" alt="">
          <img class="back" v-else src="@/assets/icon_back.png" @click="goBack" alt="">
          <img v-if="!theme" class="btn-kefu" src="@/assets/kefu.png" @click="kefu" alt=""><img v-else class="btn-kefu" src="@/assets/kefu2.png" @click="kefu" alt="">
        </div>
        <div class="cotainer">
            <h1 class="h1">{{$t('lg.ftpwds')}}</h1>
            <div class="tips">{{$t('xgdlmm.zh')}}</div>
            <div class="input-box"><input class="input" v-model="account" type="text" :placeholder="$t('lg.paccount')"></div>
            <div class="tips">{{$t('xgdlmm.yzm')}}</div>
            <div class="input-box input-pwd" v-if="lang == 'ar'"><input class="code" id="fbtain" type="button" @click="getCode" :value="$t('xgdlmm.hqyzm')"><input class="input" v-model="code" type="text" :placeholder="$t('xgdlmm.yzmts')"></div>
             <div class="input-box input-pwd" v-else><input class="input" v-model="code" type="text" :placeholder="$t('xgdlmm.yzmts')"><input class="code" id="fbtain" type="button" @click="getCode" :value="$t('xgdlmm.hqyzm')"></div>
            <div class="tips">{{$t('lg.mm')}}</div>
            <div class="input-box input-pwd">
              <input class="input" v-model="password" type="password" ref="input1" :placeholder="$t('lg.ppwd')">
              <template v-if="isPwd1">
                <img v-if="!theme" v-show="password" src="@/assets/Log-In_close-eyes.png" style="width: .6rem" @click="shpass1" />
                <img v-else v-show="password" src="@/assets/theme/eyes.png" style="width: .6rem" @click="shpass1" />
             </template>
             <template v-else>
                <img v-if="!theme" v-show="password" src="@/assets/Log-In_eyes.png" style="width: .6rem" @click="shpass1" />
                <img v-else v-show="password" src="@/assets/theme/eyes2.png" style="width: .6rem" @click="shpass1" />
             </template>
            </div>
            <div class="tips">{{$t('lg.qrmm')}}</div>
            <div class="input-box input-pwd">
              <input class="input" v-model="password_again" type="password" ref="input2" :placeholder="$t('lg.ppwd2')">
              <template v-if="isPwd2">
                <img v-if="!theme" v-show="password_again" src="@/assets/Log-In_close-eyes.png" style="width: .6rem" @click="shpass2" />
                <img v-else v-show="password_again" src="@/assets/theme/eyes.png" style="width: .6rem" @click="shpass2" />
              </template>
              <template v-else>
                <img v-if="!theme" v-show="password_again" src="@/assets/Log-In_eyes.png" style="width: .6rem" @click="shpass2" />
                <img v-else v-show="password_again" src="@/assets/theme/eyes2.png" style="width: .6rem" @click="shpass2" />
              </template>
            </div>
            <button class="btn-login btn-bg" @click="sure">{{$t('safe.sure')}}</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'forgetPwd',
    data () {
        return {
            theme: false,
            account: '',
            code: '',
            password: '',
            password_again: '',
            countdown: 300,
            timer: null,
            service_link: '',
            isPwd1: true,
            isPwd2: true,
            count: 1,
            lang: 'en'
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
      $("input").keyup(function(){	//去掉空格
        $(this).val($(this).val().replace(/[, ]/g,''));
      });
      this.getParams()
    },
    methods: {
      shpass1() {
        if(this.isPwd1){
          this.isPwd1 = false;
          this.$refs.input1.type = "text";
        }else{
          this.isPwd1 = true;
          this.$refs.input1.type = "password";
        }
      },
      shpass2() {
        if(this.isPwd2){
          this.isPwd2 = false;
          this.$refs.input2.type = "text";
        }else{
          this.isPwd2 = true;
          this.$refs.input2.type = "password";
        }
      },
       goBack(){
           this.$router.push('/login')
       },
       getParams(){
         this.$ajax.get('/web/getParam',{token: 1}).then((res) => {
              let resData = res.data.data;
              for(var i=0;i< resData.length; i++){
                if(resData[i].key == 'online_service'){
                    this.service_link = resData[i].value;
                }
              }
          }).catch(function(err){
              console.log(err)
          })
       },
       kefu(){
        if(!this.service_link) return;
        this.$router.push({ path: '/service', query: { url: this.service_link } })
       },
       sure(){
         var reg = /^(?:\d+|[a-zA-Z]+|[!@#$%^&*]+){6,12}$/;
            var params = {
                token: 1,
                account : this.account,
                code : this.code,
                password : this.password,
                password_again : this.password_again
            }
            if(params.account == '' || params.account == null){
                this.$toast.center(this.$t('lg.paccount'));
                return false;
            }
            if(params.code == '' || params.code == null){
                this.$toast.center(this.$t('xgdlmm.yzmts'));
                return false;
            }
            if(params.password == '' || params.password == null){
                this.$toast.center(this.$t('xgdlmm.mmts'));
                return false;
            }else if(!reg.test(params.password)){
                this.$toast.center(this.$t('xgdlmm.mmts'));
                return false;
            }
            if(params.password != params.password_again){
                this.$toast.center(this.$t('xgdlmm.mmts'));
                return false;
            }
            this.$ajax.post('/web/updatePassword',params).then((res) => {
                let resData = res.data;
                if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                    setTimeout(() => {
                        this.$router.push('/login')
                    }, 1000)
                }else{
                    this.$toast.center(resData.message);
                    return;
                }
            }).catch(function(err){
                console.log(err)
            })
       },
       //获取手机邮箱验证码
       getCode(){
           let params = {
               account: this.account,
               type: 'forgetpwd',
               token: 1
           }
           if(this.account == '' || this.account == null){
               this.$toast.center(this.$t('lg.paccount'));
               return;
           }
           if(this.count == 1){
              this.count = 0;
            }else{
                return false;
            }
           this.$ajax.get('/web/getCode',{params}).then((res) => {
                let resData = res.data;
                if(resData.code == 1){
                    this.$toast.center(resData.message);
                    this.count = 1;
                    return;
                }else{
                  this.count = 1;
                  this.settime()
                }

            }).catch(function(err){
                console.log(err)
            })
       },
       settime(){
           let generate_code = $("#fbtain");
           if (this.countdown == 0) {
                generate_code.attr("disabled", false);
                generate_code.val(this.$t('xgdlmm.hqyzm'));
                generate_code.css('color', '#5890bd');
                this.countdown = 300;
                return false;
            } else {
                generate_code.attr("disabled", true);
                generate_code.css('color', '#b6bfc4');
                generate_code.val(this.countdown + ' s');
                this.countdown--;
            }
            this.timer = setTimeout(() => {
                this.settime();
            }, 1000);
       },
    },
    beforeDestroy(){
      clearTimeout(this.timer);
      this.timer = null;
    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .btn-kefu{
      position: absolute;
      right: .4rem;
      top: 50%;
      width: .8rem;
      margin-top: -.4rem;
    }
    .position-box{
        position: absolute;
        width: 100%;
        height: 100%;
        background: #fff;
    }
    .cotainer{
        position: absolute;
        left: .42rem;
        right: .42rem;
        top: 1.6rem;
        bottom: 0;
        background: #fff;
        overflow-y: scroll;
    }
    .cotainer .h1{
        padding: .18rem 0 .3rem;
        color: #000;
        font-size: .78rem;
    }
    .cotainer .h3{
        color: #9f9f9f;
        font-size: .4rem;
    }
    .cotainer .tips{
        padding-top: .6rem;
        color: #000;
        font-size: .4rem;
    }
    .cotainer .input-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .44rem 0 .38rem;
        border-bottom: .01rem solid #dadada;
    }
    .cotainer .input-pwd{
        /* margin-top: .76rem; */
    }
    .cotainer .input-box .input{
        flex: 1;
        height: 100%;
        color: #000;
        font-size: .48rem;
    }
    .cotainer .input-box .input::placeholder{
        color: #c5cacd;
        font-size: .4rem;
    }
    .cotainer .input-box .code{
        color: #588bf8;
        font-size: .42rem;
    }
    .cotainer .item-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .5rem 0 1.2rem;
        font-size: .4rem;
    }
    .cotainer .btn-login{
        display: block;
        width: 100%;
        margin-top: 1.7rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/forgetPwd.vue